import { Exception } from '@core/exceptions/exception';

export class RequiredMethodCallException extends Exception {
  constructor(name: string) {
    super(`The method ${name} must be call.`);
  }
}
